import defaultState from "./defaultState";

export default () => defaultState;
